import { Link } from "react-router-dom";

const programs = [
  {
    icon: "fa-briefcase",
    title: "Boss Talk",
    tagline: "Career Development | Entrepreneurship | Leadership",
    desc: "Dynamic discussions on career development, entrepreneurship, and leadership — designed to empower you to take your business or career to the next level.",
    color: "#EC4899",
  },
  {
    icon: "fa-chart-line",
    title: "FINA-Speak",
    tagline: "Financial Wellness | Investing | Financial Literacy",
    desc: "Discover how the insurance and financial industry drives our economy and shapes a company's financial future. Paradigm Global Business Solutions hosts engaging discussions on how insurance can safeguard your company's assets and empower you to make informed, confident financial decisions.",
    color: "#F97316",
  },
  {
    icon: "fa-trophy",
    title: "Wealth Building Champions",
    tagline: "Financial Literacy | Funding | Wealth Building",
    desc: "Paradigm Global Business Solutions hosts engaging speaking events focused on financial literacy and the success of both corporations and entrepreneurs.",
    features: [
      "Funding opportunities: grants, loans, and alternative sources",
      "Financial literacy strategies tailored for companies and entrepreneurs",
      "Wealth-building frameworks designed for sustainable, long-term growth",
    ],
    color: "#E6A24A",
  },
  {
    icon: "fa-heart",
    title: "Wellness Warriors",
    tagline: "Wellness Leads to Success",
    desc: "The Wellness Warriors program promotes the fusion of success and wellness, recognizing that both are essential to a fulfilling life. Through symposiums and guided discussions, we raise awareness about health issues with a focus on multicultural diseases and chronic illnesses.",
    features: [
      "Informative discussions on cultivating a healthy, sustainable path to success",
      "Education on \"silent\" disorders and breaking health stigmas",
      "A supportive, inclusive community (chronic illness warriors welcome)",
      "Access to PGBS's network of top health professionals offering expert guidance on nutrition, fitness, stress management, and more",
    ],
    color: "#10B981",
  },
];

export const SpeakingPage = () => {
  return (
    <main data-testid="speaking-page">
      {/* PAGE HERO */}
      <div className="pg-page-hero">
        <div className="pg-container">
          <span className="pg-label">Paradigm Shift Architects</span>
          <h1>The Speaking Division</h1>
          <p>Transformative conversations that challenge the status quo</p>
        </div>
      </div>

      {/* INTRO */}
      <section className="pg-section">
        <div className="pg-container">
          <div className="pg-text-center" style={{ maxWidth: 800, margin: "0 auto" }}>
            <span className="pg-label">About the Division</span>
            <h2>Paradigm Shift Architects</h2>
            <div className="pg-divider" />
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "var(--muted)" }}>
              Paradigm Shift Architects is dedicated to helping entrepreneurs and corporations incubate long-term
              success through powerful, transformative conversations. Our speakers tackle a wide range
              of topics — each tailored to meet the specific needs of every audience. The Paradigm Shift
              Architects strive to challenge the status quo and promote innovative, effective strategies to
              attain long-term success.
            </p>
          </div>
        </div>
      </section>

      {/* SPEAKING PROGRAMS */}
      <section className="pg-section pg-section-light">
        <div className="pg-container">
          <div className="pg-text-center">
            <span className="pg-label">Our Programs</span>
            <h2>Speaking Engagements</h2>
            <div className="pg-divider" />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "2.5rem" }}>
            {programs.map((prog) => (
              <div key={prog.title} style={{
                background: "#fff", borderRadius: 20, overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,.06)", border: "1px solid var(--border)"
              }}>
                <div style={{ background: `linear-gradient(135deg, ${prog.color}, ${prog.color}cc)`, padding: "1.8rem 2rem", display: "flex", alignItems: "center", gap: "1rem" }}>
                  <div style={{ width: 52, height: 52, borderRadius: 12, background: "rgba(255,255,255,.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.3rem", color: "#fff" }}>
                    <i className={`fas ${prog.icon}`} />
                  </div>
                  <div>
                    <h3 style={{ color: "#fff", margin: "0 0 .2rem", fontSize: "1.3rem" }}>{prog.title}</h3>
                    <p style={{ color: "rgba(255,255,255,.85)", margin: 0, fontSize: ".9rem", fontStyle: "italic" }}>{prog.tagline}</p>
                  </div>
                </div>
                <div style={{ padding: "1.8rem 2rem" }}>
                  <p style={{ color: "var(--text)", fontSize: ".95rem", lineHeight: 1.7 }}>{prog.desc}</p>
                  {prog.features && (
                    <ul style={{ marginTop: "1rem", display: "flex", flexDirection: "column", gap: ".4rem" }}>
                      {prog.features.map((f) => (
                        <li key={f} style={{ display: "flex", alignItems: "flex-start", gap: ".5rem", fontSize: ".9rem", color: "var(--muted)" }}>
                          <i className="fas fa-check" style={{ color: prog.color, fontSize: ".75rem", marginTop: 4, flexShrink: 0 }} />
                          {f}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BOOK A SPEAKER */}
      <section className="pg-cta-banner">
        <div className="pg-container">
          <h2>Book a Speaker for Your Next Event</h2>
          <p>Whether it's a corporate conference, community event, or intimate workshop — our speakers deliver impact.</p>
          <div className="pg-cta-btns">
            <Link to="/consultation" className="pg-btn pg-btn-white">
              <i className="fas fa-calendar-check" /> Book a Speaker
            </Link>
            <Link to="/contact" className="pg-btn pg-btn-outline-white">
              <i className="fas fa-envelope" /> Contact Us
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SpeakingPage;
